export function host(url) {
    const host  = url.replace(/^https?:\/\//, '').replace(/\/.*$/, '')
    const parts = host.split('.').slice(-3)
    if (parts[0] === 'www') parts.shift()
    return parts.join('.')
}

export function timeAgo(time) {
    const between = Date.now() / 1000 - Number(time)
    if (between < 3600) {
        return pluralize(~~(between / 60), ' minute')
    } else if (between < 86400) {
        return pluralize(~~(between / 3600), ' hour')
    } else {
        return pluralize(~~(between / 86400), ' day')
    }
}

export function pluralize(time, label) {
    if (time === 1) {
        return time + label
    }
    return time + label + 's'
}

export function currency(value, currency, decimals) {
    value = parseFloat(value)
    if (!isFinite(value) || (!value && value !== 0)) return ''
    currency        = currency != null ? currency : '$'
    decimals        = decimals != null ? decimals : 2
    let stringified = Math.abs(value).toFixed(decimals)
    let _int        = stringified.slice(0, -1 - decimals)
    let i           = _int.length % 3
    let head        = i > 0
        ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
        : ''
    let _float      = stringified.slice(-1 - decimals)
    let sign        = value < 0 ? '-' : ''
    return sign + currency + head +
        _int.slice(i).replace(stringified, '$1,') +
        _float
}


// WEBPACK FOOTER //
// ./src/utils/filters.js